/**
 * @generated SignedSource<<7040a808026f69e16320b67214b519b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StickyHeaderChips$data = {
  readonly repository: {
    readonly nameWithOwner: string;
  };
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderAgentTasks" | "HeaderIssueType" | "HeaderSubIssueSummaryWithPrimary" | "RepositoryPill">;
  readonly " $fragmentType": "StickyHeaderChips";
};
export type StickyHeaderChips$key = {
  readonly " $data"?: StickyHeaderChips$data;
  readonly " $fragmentSpreads": FragmentRefs<"StickyHeaderChips">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StickyHeaderChips",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameWithOwner",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderIssueType"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderAgentTasks"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderSubIssueSummaryWithPrimary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RepositoryPill"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "3c90be676ae2f403b4b53dbf58b02bc1";

export default node;
